import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ExportVersionDetail, ExportVersionFile } from 'common/types';
import { RootState } from './rootReducer';

interface VersionInitialState {
  fileList: ExportVersionFile[];
  curVersion: ExportVersionDetail | undefined;
}

const initialState: VersionInitialState = {
  fileList: [],
  curVersion: undefined,
};

const version = createSlice({
  name: 'version',
  initialState,
  reducers: {
    setCurVersion(state, { payload }: PayloadAction<ExportVersionDetail | undefined>) {
      state.curVersion = payload;
    },
    setFileList(state, { payload }: PayloadAction<ExportVersionFile[]>) {
      state.fileList = payload;
    },
  },
});

export const { setCurVersion, setFileList } = version.actions;
export const selectCurVersion = (state: RootState) => state.version.curVersion;
export const selectFileList = (state: RootState) => state.version.fileList;

export default version.reducer;
